import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidatorFn, ValidationErrors } from '@angular/forms';
import { Router } from '@angular/router';
import { CognitoService } from '../../services/cognito.service';
import { PlatformApiService } from '../../services/platform-api.service';
import { SessionService } from '../../services/session.service';
import { AuthenticationType } from '../../services/oidc.factory';
import { ThemeManagerService } from 'src/app/services/theme-manager.service';

const confirmPasswordValidator:ValidatorFn = (control: FormGroup): ValidationErrors | null => {
  const confirmCheck = (control.get('newPassword') && control.get('confirmPassword') && control.get('newPassword').value != control.get('confirmPassword').value) ? {passwordNoMatch: true} : null;

  if (confirmCheck) {
    control.get('confirmPassword').setErrors({passwordNoMatch: true});
  }

  return null;
}

@Component({
  selector: 'app-new-password',
  template: `
<form [formGroup]="newpassForm" class="dashboard-tile mat-elevation-z4">
  <div class="tile-header">
    <div class="tile-header-title">
      Set New Password
    </div>
  </div>
  <div class="tile-content">
    <img mat-card-image class="tile-logo" src="{{_themeManager.getStackedLogo()}}" >
    <div class="formFieldList">
      <div *ngIf="newpassForm.errors">
        <mat-error>Invalid username/password</mat-error>
      </div>
      <div>
        <mat-hint>Passwords require at least:<br>8 characters<br>1 uppercase<br>1 lowercase<br>1 number<br>1 special character</mat-hint>
      </div>
      <mat-form-field>
        <input matInput placeholder="Email Address" formControlName="email" required readonly>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Password" formControlName="newPassword" type="password" pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$" required>
        <mat-hint>at least 8 characters, 1 uppercase, 1 lowercase, 1 number, and 1 special character</mat-hint>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Confirm Password" formControlName="confirmPassword" type="password" >
        <mat-error *ngIf="newpassForm.controls.confirmPassword?.errors?.passwordNoMatch">Doesn't match password</mat-error>
      </mat-form-field>
    </div>
    <div class="tile-footer centered">
    <button mat-button type="button" color="primary" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" type="submit" (click)="onSave()">Login</button>
    </div>
  </div>
</form>
`,
  styleUrls: ['./auth.layout.scss']
})
export class NewPasswordComponent implements OnInit {
  @Output() stateChange: EventEmitter<any> = new EventEmitter();
  @Input() email;
  @Input() existingPassword;

  newpassForm = new FormGroup ({
    email: new FormControl('', [Validators.required, Validators.email]),
    newPassword: new FormControl('', [Validators.required]),
    confirmPassword: new FormControl('', [Validators.required])
  }, [confirmPasswordValidator]);

  constructor(public _themeManager: ThemeManagerService, private _cognitoService: CognitoService, private _sessionService: SessionService, private _platformApi: PlatformApiService, private _router: Router) { }

  ngOnInit() {
    this.newpassForm.controls.email.setValue(this.email);
  }

  onCancel() {
    this.stateChange.emit({state:'LOGIN'});
  }

  onSave() {
    if (this.newpassForm.status == 'VALID') {
      this._cognitoService.newPassword(this.email, this.existingPassword, this.newpassForm.value.newPassword).then(
        success => {
          if (success == 'SUCCESS') {
            this._sessionService.setAuthenticationType(AuthenticationType.COGNITO);
            this._platformApi.getCredentials().subscribe(
              cred => {
                this._sessionService.setApiCredentials(cred);
                this.stateChange.emit({state:'LOGINSUCCESS'});
              }, err => {
                this._sessionService.logout();
                this.stateChange.emit({state:'UNAUTHORIZED'});
              }
            )
          } else if (success.status == 'MFAREQUIRED' || success.status == 'SETUPTOTPMFA') {
            this.stateChange.emit({state:success.status, secretCode: success.secretCode, cognitoUser: success.cognitoUser});
          }
        },
        error => {
          console.log(error);
          if (error.code === 'UserNotConfirmedException') {
            this.stateChange.emit({state:'REGISTRATIONCONFIRM', username:this.newpassForm.value.email});
          } else {
            this.newpassForm.setErrors({invalidUser: true});
          }
        });
    }
  }
}
